export const DATA_TYPE_NAMES = {
    AUDIT_POLICIES: "AUDIT_POLICIES",
    DEVICES: "DEVICES",
    FILES: "FILES",
    OS_PLANS: "OS_PLANS",
    SCHEDULES: "SCHEDULES",
    FILE_SERVERS: "FILE_SERVERS",
};

export const CONTENT_TYPE = {
    ERROR: "error",
    NOT_INITIALIZED: "not_initialized",
    DATA: "data",
    EMPTY: "empty",
};

export const NUMBER_OF_ITEMS_OPTIONS = [
    {value: 2, label: "2"},
    {value: 5, label: "5"},
    {value: 10, label: "10"},
    {value: 20, label: "20"},
    {value: -1, label: "All"},
];

export const AUTO_REFRESH_OPTIONS = [
    {value: 300000, label: "Every 5 minutes"},
    {value: 3600000, label: "Every hour"},
    {value: 86400000, label: "Every day"},
];

export const WIDGET_NAME_MAPPING = {
    DisplayWidget: "bulletin",
    RSSFeedWidget: "rss feed",
    WebPageWidget: "web page",
    ScheduledActivityWidget: "scheduled activities",
    UserActivityWidget: "user activity",
    GridWidget: "grid",
    DatasetChartWidget: "dataset chart",
    CountWidget: "count",
    TaskListWidget: "task list",
    BasicCalculator: "calculator",
    Ipv4SubnetCalculator: "IPv4 subnet calculator",
};

export const PING_PACKET_SIZE_OPTIONS = [
    {value: 64, label: 64},
    {value: 128, label: 128},
    {value: 256, label: 256},
    {value: 512, label: 512},
    {value: 1024, label: 1024},
];
